import api from "../../domain/api";
import {
  GET_LEADS_STATED,
  GET_LEADS,
  GET_LEADS_ENDED,
  ADD_LEAD_STATED,
  ADD_LEAD,
  ADD_LEAD_ENDED,
  EDIT_LEAD_STATED,
  EDIT_LEAD,
  EDIT_LEAD_ENDED,
  GET_LEAD_STATED,
  GET_LEAD,
  GET_LEAD_ENDED,
  GET_ALL_LEADS_STATED,
  GET_ALL_LEADS,
  GET_ALL_LEADS_ENDED,
} from "../types/lead_type";
import * as qs from "qs";
import { handleError } from "../../shared/handleError";
import { setAlert } from "./alert";

export const addLead = (formData) => async (dispatch, getState) => {
  try {
    dispatch({
      type: ADD_LEAD_STATED,
    });
    const { data } = await api.post(`/leads`, formData);
    dispatch({
      type: ADD_LEAD,
      payload: data,
    });
    dispatch({
      type: ADD_LEAD_ENDED,
    });
  } catch (error) {
    dispatch({
      type: ADD_LEAD_ENDED,
    });
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const getLeads =
  ({ pageNumber = ""}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: GET_LEADS_STATED,
      });
      const queryParams = qs.parse(window.location.search.replace("?", ""));
      const query = qs.stringify(queryParams, {
        encodeValuesOnly: true, // prettify url
      });

      const { data } = await api.get(
        `/leads?&pageNumber=${pageNumber}&${query}`
      );

      dispatch({
        type: GET_LEADS,
        payload: data,
      });
      dispatch({
        type: GET_LEADS_ENDED,
      });
    } catch (error) {
      dispatch({
        type: GET_LEADS_ENDED,
      });
      dispatch(handleErrorLocal(error));
      dispatch(handleError(error));
    }
  };
export const getLead = (id) => async (dispatch) => {
  try {
    dispatch({
      type: GET_LEAD_STATED,
    });
    const { data } = await api.get(`/leads/${id}`);

    dispatch({
      type: GET_LEAD,
      payload: data,
    });
    dispatch({
      type: GET_LEAD_ENDED,
    });
  } catch (error) {
    dispatch({
      type: GET_LEAD_STATED,
    });
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const editLead = (id, formData) => async (dispatch) => {
  try {
    dispatch({
      type: EDIT_LEAD_STATED,
    });
    const { data } = await api.put(`/leads/${id}`, formData);
    dispatch({
      type: EDIT_LEAD,
      payload: data,
    });
    dispatch({
      type: EDIT_LEAD_ENDED,
    });
  } catch (error) {
    dispatch({
      type: EDIT_LEAD_ENDED,
    });
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const deleteLead = (id) => async (dispatch) => {
  try {
    const { data } = await api.delete(`/leads/${id}`);
    dispatch(setAlert("Lead Deleted Successfully", "success"));
  } catch (error) {
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const getAllLeads = ({ term, value }) => async (dispatch) => {
  try {
    dispatch({
      type: GET_ALL_LEADS_STATED,
    });
    const { data } = await api.get(`/leads/all?term=${term}&value=${value}`);

    dispatch({
      type: GET_ALL_LEADS,
      payload: data,
    });
    dispatch({
      type: GET_ALL_LEADS_ENDED,
    });
  } catch (error) {
    dispatch({
      type: GET_ALL_LEADS_ENDED,
    });
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};

export const handleErrorLocal = () => async (dispatch) => {};
